import { render, staticRenderFns } from "./Overlay.vue?vue&type=template&id=3417d3e8"
import script from "./Overlay.vue?vue&type=script&lang=js"
export * from "./Overlay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports